import { MdsIconKind } from "@/design-system/components/icon";
import { NoteSuggestionRefineActions } from "@/components/note/floating-actions/NoteSuggestionRefineActions";
import { MemCommonEditorStore } from "@/components/note/store/MemCommonEditorStore";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import styled from "@emotion/styled";
import { NoteObservable } from "@/store/note/NoteObservable";
import {
  MDSButton,
  MDSButtonIcon,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIconButton,
  MDSIconButtonSize,
  MDSText,
  MDSTextVariant,
} from "@/mds";

interface NoteSuggestionActionsProps {
  editorStore: MemCommonEditorStore;
}

export const NoteSuggestionActions = observer(function NoteSuggestionActions({
  editorStore,
}: NoteSuggestionActionsProps) {
  const isRefineEnabled =
    editorStore.noteObservable instanceof NoteObservable &&
    !!editorStore.noteObservable.suggestionData;
  const [showRefineInput, setShowRefineInput] = useState(false);

  if (showRefineInput && editorStore.noteObservable instanceof NoteObservable) {
    return (
      <NoteSuggestionRefineActions
        noteObservable={editorStore.noteObservable}
        setShowRefineInput={setShowRefineInput}
      />
    );
  }

  return (
    <StyledContainer>
      <MDSText variant={MDSTextVariant.TextSm}>Edited Note</MDSText>
      <StyledSButton isDisabled={!isRefineEnabled} onClick={() => setShowRefineInput(true)}>
        <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={MdsIconKind.Sparkle} />
        Refine
      </StyledSButton>
      <StyledSButton
        variant={MDSButtonVariant.Contrast}
        onClick={() => editorStore.closeSuggestion(true)}
      >
        <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={MdsIconKind.Check} />
        Accept
      </StyledSButton>
      <MDSIconButton
        onClick={() => editorStore.closeSuggestion(false)}
        iconKind={MdsIconKind.Exit}
        size={MDSIconButtonSize.Medium}
      />
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.surface.modal};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  box-shadow: ${({ theme }) => theme.shadows.surface};
  gap: ${({ theme }) => theme.spacing["2"]};
  justify-content: flex-start;
  padding: ${({ theme }) =>
    `${theme.spacing["4"]} ${theme.spacing["4"]} ${theme.spacing["4"]} ${theme.spacing["6"]}`};
`;

const StyledSButton = styled(MDSButton)`
  width: 122.333px;
`;
